import { Component, OnInit, Optional } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { StringHelper } from '../../../../core/helpers/strings.helper';
import { GeneralService } from '../../../../core/services/general.service';
import { LocalStorageService } from '../../../../core/services/local-storage.service';
import { EndOfYearSummmaryModel } from '../../../../shared/models/end-of-year-summary.model';
import { StorageKeys } from '../../../../shared/models/storage-keys';

@Component({
  selector: 'app-yearly-review-report-modal',
  templateUrl: './yearly-review-report-modal.component.html',
  styleUrls: ['./yearly-review-report-modal.component.scss']
})
export class YearlyReviewReportModalComponent implements OnInit {

  loading: boolean;
  errorMessage: string;
  userName: string;
  endOfYearSummary: EndOfYearSummmaryModel;

  constructor(@Optional() public modalService: NzModalRef, private generalService: GeneralService,
    public localStorage: LocalStorageService) { }

  ngOnInit(): void {
    const agentId = this.localStorage.get(StorageKeys.businessId);
    this.userName = this.localStorage.get(StorageKeys.username);
    this.initialize(agentId);
  }

  initialize(agentId: string) {
    this.loading = true;
    this.generalService.getEndOfYearSummaryReport(agentId)
      .then(res => {
        this.loading = false;
        this.endOfYearSummary = res?.summary;
      })
      .catch(error => {
        this.loading = false;
        this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(error);
      })
  }

}
